import "./clinic-item.scss";
import ImageCommon from "@/src/component/image/image";
import { Row, Col, Button } from "antd";
import Image from "next/image";
import tickIcon from "@/public/icon/tick-icon.svg";
import promotionTagIcon from "@/public/icon/promotion-tag-icon.svg";
import iconStar from "@/public/icon/icon-start-3d.svg";
import chevronDown from "@/public/icon/chevron-down.png";
import Link from "next/link";
import { convertToMillionRange } from "@/src/util/util";
import useWindowSize from "@/src/hooks/useWindowSize";
import { useEffect, useState, useMemo } from "react";
import iconLocation from "@/public/icon/icon-location-circle.svg";

export function ClinicItem({
  clinic,
  type,
  service_id,
  setClinicDetail,
  setOpenContact,
  setOpenBooking,
}) {
  return (
    <div className="clinic-card">
      <Row gutter={[22, { xs: 15, md: 22 }]}>
        <Col xs={24} lg={12}>
          <div className="clinic-card__left">
            <Link href={`/phong-kham/${clinic.slug}`}>
              <ImageCommon data={clinic.image[0]} style="clinic-card__logo" />
            </Link>
            <div>
              <div className="clinic-card__meta">
                <Link href={`/phong-kham/${clinic.slug}`}>
                  <h2 className="clinic-card__title">{clinic.name}</h2>
                </Link>

                <p className="clinic-card__address">
                  <Image
                    src={iconLocation}
                    className="clinic-icon-location"
                    alt="Location icon"
                    width={20}
                    height={20}
                  />
                  {clinic.address?.[0]?.detail_address}
                </p>
                <div className="wpRatingLine">
                  {clinic?.rating_overview?.overall_average ? (
                    <div className="wpRatingInLine">
                      <div className="ratingPoint">
                        <div className="point">
                          {clinic?.rating_overview?.overall_average.toFixed(1)}
                        </div>
                        <Image
                          className="iconRatingStar"
                          src={iconStar}
                          alt="icon"
                        />
                      </div>
                      <div className="dash"></div>
                    </div>
                  ) : null}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div className="ratingQuantity">
                      {clinic?.rating_overview?.number_of_ratings} Đánh giá
                    </div>
                    <div className="dash"></div>
                    <div className="numberOfConsultation">
                      {clinic?.total_contact ? clinic?.total_contact : 0} Người
                      đặt lịch
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {clinic?.promotion_text?.length > 0 && clinic?.promotion_text[0] && (
            <div className="wpPromotionText">
              {clinic?.promotion_text[0]?.split(/\s*[;]\s*/)?.map((item) => {
                return (
                  <div className="promotionItem">
                    <Image
                      src={promotionTagIcon}
                      alt="promotionTagIcon"
                      width={16}
                      height={16}
                      className="promotionTagIcon"
                    />
                    {item}
                  </div>
                );
              })}
            </div>
          )}
          {clinic?.tag_clinic?.length > 0 && (
            <div className="wpUtilities">
              {clinic.tag_clinic.map((tag) => (
                <div className="utilitiesItem">
                  <Image
                    src={tickIcon}
                    alt="tickIcon"
                    width={14}
                    height={14}
                    className="tickIcon"
                  />
                  {tag?.tag?.name}
                </div>
              ))}
            </div>
          )}
          {/* <span
            className="clinic-card__desc line-clamp"
            dangerouslySetInnerHTML={{ __html: clinic.introduce }}
          /> */}
        </Col>

        <Col xs={24} lg={12} className="wp-clinic-right">
          <div className="clinic-card__price">
            <PriceService
              data={clinic?.category_service_clinic}
              type={type}
              service_id={service_id}
            />
          </div>
          <div className="clinic-card__button">
            <Button
              onClick={() => {
                setClinicDetail(clinic);
                setOpenContact(true);
              }}
            >
              Nhận tư vấn
            </Button>
            <Button
              onClick={() => {
                setClinicDetail(clinic);
                setOpenBooking(true);
              }}
            >
              Đặt lịch giữ chỗ
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export function BrandItem({
  brand,
  type,
  service_id,
  province_name,
  setClinicDetail,
  setOpenContact,
  setOpenBooking,
}) {
  const brandPriceData = brand.clinic.find(
    (item) => item.category_service_clinic.length > 0
  );
  return (
    <div className="brand-item">
      <div className="brand-item__info">
        <ImageCommon
          data={brand.image}
          alt={"logo"}
          style="brand-item__info-logo"
        />
        <h2>{brand.name}</h2>
      </div>
      <div className="brand-item__price">
        <PriceService
          data={brandPriceData?.category_service_clinic}
          type={type}
          service_id={service_id}
        />
      </div>
      <p>
        Các chi nhánh tại{" "}
        {province_name == "Hồ Chí Minh" ? "TP. Hồ Chí Minh" : province_name}
      </p>
      <Row gutter={[40, { xs: 15, md: 20 }]}>
        {brand?.clinic?.map((item) => {
          return (
            <Col xs={24} md={12}>
              <div className="brand-item__clinic">
                <div className="brand-item__clinic-info">
                  <Link
                    href={`/phong-kham/${item.slug}`}
                    className="brand-item__clinic-info-name"
                  >
                    {item.name}
                  </Link>
                  <div className="brand-item__clinic-statistics">
                    {item?.rating_overview?.overall_average != 0 && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="brand-item__clinic-rating">
                          <div className="brand-item__clinic-rating-point">
                            {item?.rating_overview?.overall_average.toFixed(1)}
                          </div>
                          <Image
                            className="brand-item__clinic-rating-icon"
                            src={iconStar}
                            alt="icon"
                          />
                        </div>
                        <div className="brand-item__clinic-statistics-dash"></div>
                      </div>
                    )}
                    <span>
                      {item?.rating_overview?.number_of_ratings} Đánh giá
                    </span>
                    <div className="brand-item__clinic-statistics-dash"></div>
                    <span>{item?.total_contact || 0} Người đặt lịch</span>
                  </div>
                </div>
                <div className="brand-item__clinic-button">
                  <Button
                    onClick={() => {
                      setClinicDetail(item);
                      setOpenContact(true);
                    }}
                  >
                    Nhận tư vấn
                  </Button>
                  <Button
                    onClick={() => {
                      setClinicDetail(item);
                      setOpenBooking(true);
                    }}
                  >
                    Đặt lịch giữ chỗ
                  </Button>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

const priorityServices = [
  "Niềng răng",
  "Trồng răng Implant",
  "Bọc răng sứ",
  "Nhổ răng khôn",
  "Răng giả tháo lắp",
  "Trám răng",
];

const PriceService = ({ data = [], type, service_id }) => {
  const [priceExpanded, setPriceExpanded] = useState(false);
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const isDesktop = width >= 1200;

  const onlyOneServicePrice = type === "SERVICE";
  const isDistrictLdp = type === "DISTRICT";

  const listPrice = useMemo(() => {
    if (onlyOneServicePrice) {
      const matchedCategory = data.find(
        (item) => item?.category_service?.id === service_id
      );

      return (
        matchedCategory?.service?.map((item) => ({
          name: item?.name,
          minAmount: item?.amount,
          maxAmount: item?.amount_max,
        })) || []
      );
    }

    const priorityMap = new Array(priorityServices.length);
    const nonPriorityList = [];

    data.forEach((item) => {
      if (!item?.service?.length) return;
      const index = priorityServices.indexOf(item?.category_service?.name);
      if (index !== -1) {
        priorityMap[index] = item;
      } else {
        nonPriorityList.push(item);
      }
    });

    const combinedList = [
      ...priorityMap.filter(Boolean),
      ...(isDistrictLdp ? [] : nonPriorityList),
    ];

    return combinedList.map((item) => {
      const minAmount = Math.min(...item.service.map((s) => s.amount));
      const maxAmount = Math.max(...item.service.map((s) => s.amount_max));
      return {
        name: item?.category_service?.name,
        minAmount,
        maxAmount,
      };
    });
  }, [data, type, service_id, isDistrictLdp, onlyOneServicePrice]);

  const maxVisible = isMobile ? 4 : isDesktop ? 9 : 8;
  let visiblePriceList = listPrice;

  if (!isDistrictLdp && !priceExpanded) {
    visiblePriceList = listPrice.slice(0, maxVisible);
  }
  //district ldp dont need expand
  const showExpandButton = listPrice.length > maxVisible && !isDistrictLdp;

  return (
    <div className="list-price">
      <Row gutter={[isDistrictLdp ? 10 : 15, 10]}>
        {visiblePriceList.map((item, index) => (
          <Col key={index} xl={isDistrictLdp ? 12 : 8} md={12} xs={24}>
            <div className="price-item">
              <div className="price-item__name">{item.name}</div>
              <div className="price-item__amount">
                {convertToMillionRange(item.minAmount, item.maxAmount)}
              </div>
            </div>
          </Col>
        ))}
      </Row>
      {showExpandButton && (
        <button
          className="list-price__btn"
          onClick={() => setPriceExpanded((prev) => !prev)}
        >
          <span>{priceExpanded ? "Thu gọn" : "Xem thêm"}</span>
          <Image
            src={chevronDown}
            alt="icon"
            width={13}
            height={13}
            style={{
              transform: `rotate(${priceExpanded ? -90 : 90}deg)`,
              transition: "transform 0.3s ease",
            }}
          />
        </button>
      )}
    </div>
  );
};
